module.exports = __webpack_public_path__ + "static/reviews-e3b49df4ab1ef5d01c40098eb4b125aa.webp";